import type { Element as HastElement } from 'hast';
import type { ExtraProps } from 'react-markdown';
import type { ReactNode } from 'react';

import { renderCmsMarkdownComponent } from './cmsMarkdownDirectiveRender';

function hastPropertiesToStringRecord(properties: HastElement['properties']): Record<string, string> {
    if (!properties) {
        return {};
    }

    const out: Record<string, string> = {};

    for (const [key, value] of Object.entries(properties)) {
        if (typeof value === 'string') {
            out[key] = value;
            continue;
        }

        if (Array.isArray(value)) {
            const strings = value.filter((v): v is string => typeof v === 'string');
            if (strings.length > 0) {
                out[key] = strings.join(' ');
            }
            continue;
        }

        if (typeof value === 'number' || typeof value === 'boolean') {
            out[key] = String(value);
        }
    }

    return out;
}

/** Maps HAST `cms-component` nodes from remark to the typed CMS registry. */
export function CmsMarkdownDirectiveHost({ node }: ExtraProps): ReactNode {
    if (!node || node.type !== 'element') {
        return null;
    }

    const raw = hastPropertiesToStringRecord(node.properties);
    const componentType = raw['data-cms-type'] ?? raw['dataCmsType'];
    if (!componentType) {
        return null;
    }

    const { ['data-cms-type']: _a, dataCmsType: _b, ...componentProps } = raw;
    return renderCmsMarkdownComponent(componentType, componentProps);
}
